/**
 * Provides base url as window.location.origin or as passed default value, if origin is local webserver
 */
import contains from 'mout/array/contains';

const localUrls = ['127.0.0.1', '::1', 'localhost', '0:0:0:0:0:0:0:1'];

export default class BaseUrlDetector {
  /*@ngInject*/
  constructor($window) {
    this.$window = $window;
  }

  get isLocalUrl() {
    return contains(localUrls, this.$window.location.hostname);
  }

  getBaseUrlFromLocation(appPath) {
    const fullPath = this.$window.location.origin + this.$window.location.pathname;

    if (fullPath.indexOf(appPath) !== -1) {
      return fullPath.replace(appPath, '');
    }

    throw new Error(
      `getBaseUrlFromLocation failed: Location "${fullPath}" doesn\'t contains application route "${appPath}"`
    );
  }

  /**
   * If window origin is some kind of local server, returns defaultUrl. Elsewhere returns window origin.
   * @param defaultUrl, - url to return if window origin is local
   */
  getOriginOrDefaultUrl(defaultUrl, appPath) {
    if (this.isLocalUrl) {
      return defaultUrl;
    }
    return this.getBaseUrlFromLocation(appPath);
  }
}



// WEBPACK FOOTER //
// ./src/blocks/base-url/base-url__detector.js